import "./css/index.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

import WebRoutes from "./routes/web";
import { Helmet } from "react-helmet";
import ScrollToTop from "./components/setting/ScrollToTop";

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/*" element={<WebRoutes />} />
      </Routes>
    </>
  );
}

function AppInitializer() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Helmet>
        <title>
          Kaanshi Films Entertainment (KFE) | Film & Video Production House
          Mumbai
        </title>
      </Helmet>
      <App />
    </BrowserRouter>
  );
}

// Render root
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppInitializer />);
